module.exports = __webpack_public_path__ + "static/media/spin@3x.c2246c01.png";